const removeDuplicates = (list, prop) => list.reduce((accumulator, listItem) => {
  if (accumulator.length === 0
    || !accumulator.find(savedItem => (
      savedItem[prop] && savedItem[prop].toLowerCase() === listItem[prop].toLowerCase()))) {
    accumulator.push(listItem);
  }

  return accumulator;
}, []);

const sortAlphabeticallyByProp = (list, prop) => (
  list.sort((a, b) => {
    const propA = a[prop].toLowerCase();
    const propB = b[prop].toLowerCase();

    return propA.localeCompare(propB);
  })
);

const sortSubjects = (list, locale) => (
  list.sort((a, b) => {
    const first = a.node || a;
    const second = b.node || b;

    return first.labels[locale].localeCompare(second.labels[locale]);
  })
);

const sortProgramsByType = (programs) => {
  const programsByType = {};
  const sortedPrograms = sortAlphabeticallyByProp(programs, 'title');
  sortedPrograms.forEach((program => {
    const { type } = program;
    if (type in programsByType) {
      programsByType[type].push(program);
    } else {
      programsByType[type] = [program];
    }
  }));

  return programsByType;
};

export {
  removeDuplicates,
  sortAlphabeticallyByProp,
  sortProgramsByType,
  sortSubjects,
};
